import { CommonModule } from '@angular/common';
import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IgxGridComponent, IgxGridModule } from '@infragistics/igniteui-angular';
import { DataService } from 'src/app/core/services/data/data.service';
import { ILotDisableSpace, IGbInvoiceLineItemDescriptionCustomizationResponse } from 'src/app/shared/interfaces';

@Component({
  selector: 'app-gb-invoice-line-description-override',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatTooltipModule,
    IgxGridModule,
  ],
  templateUrl: './gb-invoice-line-description-override.component.html',
  styleUrl: './gb-invoice-line-description-override.component.scss',
})
export class GbInvoiceLineDescriptionOverrideComponent implements OnInit {
  spaceDisableLotList: ILotDisableSpace[] = [];
  allLotsActiveAndDisabledList: ILotDisableSpace[] = [];
  selectedLotNumber: string = '';
  selectedLotSetCustomizationOn: boolean = false;

  public gridGbEnabledCustomDescription: IgxGridComponent;

  lotGbInvoiceLineDescriptionStatusList: IGbInvoiceLineItemDescriptionCustomizationResponse[] = [];

  //SERVICES
  dataService = inject(DataService);
  snackBarService = inject(MatSnackBar);
  destroyRefService = inject(DestroyRef);

  ngOnInit(): void {
    this.GetListOfInvoiceLineItemDescriptionStatus();
    this.GetListOfAllLots();
  }

  GetListOfAllLots() {
    this.dataService.getAllLotsAdminSpaceDisable().subscribe(
      (res) => {
        this.allLotsActiveAndDisabledList = res;
      },
      (err: any) => {},
      () => {},
    );
  }

  onUpdateLotForInvoiceLineDescriptionCustomization(): void {
    this.UpdateInvoiceDescriptionCustomizationToFalse(this.selectedLotNumber, true);
    this.selectedLotSetCustomizationOn = true;
  }

  GetListOfInvoiceLineItemDescriptionStatus() {
    this.dataService.GetsLotListInvoiceLineItemDescriptionStatus().subscribe(
      (res) => {
        this.lotGbInvoiceLineDescriptionStatusList = res;
      },
      (err: any) => {},
      () => {},
    );
  }

  OnLotNumberChange(lotNumber: string): void {
    this.selectedLotNumber = lotNumber;
    this.selectedLotSetCustomizationOn = this.GetCustomizationStatus(lotNumber);
  }

  // OnUpdateSpaceDisableSetting(): void {
  //   let spaceDisableSettings: ILotDisableSpace = {} as ILotDisableSpace;

  //   spaceDisableSettings.lotNumber = this.selectedLotNumber;
  //   spaceDisableSettings.spaceDisable = true;
  //   spaceDisableSettings.location = this.GetLocationByLotNumber(this.selectedLotNumber);

  //   this.UpdateSpaceDisableStatusToDisabled(spaceDisableSettings);
  // }

  GetLocationByLotNumber(lotNumber: string): string {
    let location: string = '';
    let ii: number;

    for (ii = 0; ii < this.spaceDisableLotList.length; ii++) {
      if (this.spaceDisableLotList[ii].lotNumber == lotNumber) {
        location = this.spaceDisableLotList[ii].location;
        break;
      }
    }

    return location;
  }

  GetCustomizationStatus(lotNumber: string): boolean {
    let customizationStatus: boolean = false;
    let ii: number;

    for (ii = 0; ii < this.lotGbInvoiceLineDescriptionStatusList.length; ii++) {
      if (this.lotGbInvoiceLineDescriptionStatusList[ii].lotNumber == lotNumber) {
        customizationStatus = this.lotGbInvoiceLineDescriptionStatusList[ii].isCustomizable;
        break;
      }
    }

    return customizationStatus;
  }

  // UpdateSpaceDisableStatusToDisabled(spaceDisableSettings: ILotDisableSpace): void {
  //   let status: boolean;

  //   this.dataService
  //     .UpdateSpaceDisable(spaceDisableSettings)
  //     .pipe(takeUntilDestroyed(this.destroyRefService))
  //     .subscribe({
  //       next: (res) => {
  //         status = res;
  //       },
  //       error: (err: any) => {
  //         this.snackBarService.open(
  //           'An unexpected error occurred while updating the Space Disable status for this lot.',
  //           '',
  //           { duration: 3000 },
  //         );
  //       },
  //       complete: () => {
  //         this.selectLotDisabled = spaceDisableSettings.spaceDisable;
  //         this.GetListOfAllLots();
  //         this.GetSpaceDisableLotList();
  //         this.snackBarService.open('The Lot Number has been added to the spAce Disabled List.', '', {
  //           duration: 3000,
  //         });
  //       },
  //     });
  // }

  UpdateLotSettings(lotNumber: string, spaceDisableSetting: boolean): void {
    let ii: number;

    for (ii = 0; ii < this.spaceDisableLotList.length; ii++) {
      if (this.spaceDisableLotList[ii].lotNumber == lotNumber) {
        this.spaceDisableLotList[ii].spaceDisable = spaceDisableSetting;
        break;
      }
    }
  }

  SetLotOnspaceDisableLotListToFalse(lotNumber: string): void {
    let ii: number;

    for (ii = 0; ii < this.spaceDisableLotList.length; ii++) {
      if (this.spaceDisableLotList[ii].lotNumber == lotNumber) {
        this.spaceDisableLotList[ii].spaceDisable = false;
        break;
      }
    }
  }

  UpdateInvoiceDescriptionCustomizationToFalse(lotNumber: string, settingStatus: boolean): void {
    let status: boolean;

    this.dataService
      .SetLotGbLineItemCustomizationStatus(lotNumber, settingStatus)
      .pipe(takeUntilDestroyed(this.destroyRefService))
      .subscribe({
        next: (res) => {
          status = res;
        },
        error: (err: any) => {
          this.snackBarService.open(
            'An unexpected error occurred while updating the Invoice Line Description Customization status for this lot.',
            '',
            { duration: 3000 },
          );
        },
        complete: () => {
          this.snackBarService.open(
            'The Lot Number has been removed from the Invoice Line Description Customization list.',
            '',
            {
              duration: 3000,
            },
          );
          this.GetListOfAllLots();
          this.selectedLotSetCustomizationOn = false;
          this.GetListOfInvoiceLineItemDescriptionStatus();
        },
      });
  }

  UpdateInvoiceDescriptionCustomizationToTrue(lotNumber: string): void {
    let status: boolean;

    this.dataService
      .SetLotGbLineItemCustomizationStatus(lotNumber, true)
      .pipe(takeUntilDestroyed(this.destroyRefService))
      .subscribe({
        next: (res) => {
          status = res;
        },
        error: (err: any) => {
          this.snackBarService.open(
            'An unexpected error occurred while updating the Invoice Line Description Customization status for this lot.',
            '',
            { duration: 3000 },
          );
        },
        complete: () => {
          this.snackBarService.open(
            'The Lot Number has been added to the Invoice Line Description Customization list.',
            '',
            {
              duration: 3000,
            },
          );
          this.GetListOfAllLots();
          this.GetListOfInvoiceLineItemDescriptionStatus();
        },
      });
  }
}
